import { render, staticRenderFns } from "./snackbar.component.vue?vue&type=template&id=4a6ab06f&scoped=true&"
import script from "./snackbar.component.vue?vue&type=script&lang=ts&"
export * from "./snackbar.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ab06f",
  null
  
)

export default component.exports